<style src="./ImportQuoteFromMap.scss" lang="scss"></style>
<template>
  <section class="import-quote-from-map">
    <div class="event-info row">
      <div class="col-6">
        <suggest-event
          @selected="selectEvent" />
        <input
          type="file"
          name="uploadFile"
          ref="fileInput"
          accept="text/*.csv"
          class="input-file">
        <button
          class="btn-primary"
          type="file"
          @click="loadMap">
          Abrir MAPA
        </button>
      </div>
      <div class="col-6">
        <button
          class="btn-success"
          @click="saveResult">
          Salvar Resultado
        </button>
      </div>
    </div>

    <div class="map-items">
      <table class="itemtable">
        <thead>
          <tr class="header">
            <th colspan="4"></th>
            <th colspan="2" class="left-border right-border">SISTEMA</th>
            <th colspan="2" class="right-border">MAPA</th>
            <th colspan="2" class="right-border">PROPOSTA</th>
            <th colspan="3" class="right-border">1º COLOCADO</th>
            <th colspan="3" class="right-border">2º COLOCADO</th>
            <th colspan="3" class="right-border">3º COLOCADO</th>
          </tr>
          <tr class="subheader bottom-border">
            <th class="price">ME</th>
            <th class="price">GARANTIA</th>
            <th class="lot">LOTE</th>
            <th class="number">ITEM</th>
            <!-- <th class="code left-border">CÓDIGO</th> -->
            <th class="price left-border">CUSTO</th>
            <th class="lab right-border">MARCA</th>
            <th class="price">CUSTO</th>
            <th class="lab right-border">MARCA</th>
            <th class="price">V.UNIT</th>
            <th class="price right-border">V. MIN</th>
            <th class="price">V.UNIT</th>
            <th class="lab">DISTRIBUIDOR</th>
            <th class="lab right-border">MARCA</th>
            <th class="price">V.UNIT</th>
            <th class="lab">DISTRIBUIDOR</th>
            <th class="lab right-border">MARCA</th>
            <th class="price">V.UNIT</th>
            <th class="lab">DISTRIBUIDOR</th>
            <th class="lab right-border">MARCA</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, itemIdx) in items"
            :key="itemIdx"
            :class="{ 'notquoted': (item.mapInfo && !item.mapInfo.cost) }">
            <td>{{ item.mapInfo && item.mapInfo.strictToME }}</td>
            <td>{{ item.mapInfo && item.mapInfo.priceGuaranted }}</td>

            <!-- EDITAL -->
            <td>{{ item.itemInfo && item.itemInfo.lot }}</td>
            <td>{{ item.itemInfo && item.itemInfo.number }}</td>

            <!-- SISTEMA -->
            <td class="left-border">{{ item.itemQuoted && item.itemQuoted.cost }}</td>
            <td class="right-border">{{ item.itemQuoted && item.itemQuoted.lab }}</td>
            
            <!-- MAPA -->
            <td>{{ item.mapInfo && item.mapInfo.cost }}</td>
            <td
              :class="{ 'wrong-lab': item.itemInfo.cost && (item.mapInfo && item.mapInfo.lab) && ((item.mapInfo && item.mapInfo.lab) !== (item.itemQuoted && item.itemQuoted.lab)) }"
              class="right-border">
              {{ item.mapInfo && item.mapInfo.lab }}
            </td>

            <!-- PROPOSTA -->
            <td>{{ item.mapInfo && item.mapInfo.proposalPrice }}</td>
            <td class="right-border">{{ item.mapInfo && item.mapInfo.minimumPrice }}</td>

            <!-- WINNER -->
            <td>{{ (item.mapInfo && item.mapInfo.haveWinner && item.mapInfo.winnerCost) || '' }}</td>
            <td>
              <span
                v-if="item.mapInfo && item.mapInfo.winnerId"
                @click="cleanDistributor(item, 'winner')">
                {{ (item.mapInfo && item.mapInfo.haveWinner && item.mapInfo.winnerSupplier) || '' }}
              </span>
              <suggest-distribuitor
                :title="item.mapInfo.winnerSupplier"
                v-if="item && item.mapInfo && item.mapInfo.haveWinner && !item.mapInfo.winnerId"
                label="Distribuidora"
                placeholder="empresa"
                v-model="item.mapInfo.winnerSupplier"
                @selected="(selected) => selectDistributor({ selected, item, position: 'winner' })"
                class="suggest" />
            </td>
            <td class="right-border">{{ (item.mapInfo && item.mapInfo.haveWinner && item.mapInfo.winnerLab) || '' }}</td>
            <td>{{ (item.mapInfo && item.mapInfo.haveSecond && item.mapInfo.secondCost) || '' }}</td>
            <td>
              <span
                v-if="item.mapInfo && item.mapInfo.secondId"
                @click="cleanDistributor(item, 'second')">
                {{ (item.mapInfo && item.mapInfo.haveSecond && item.mapInfo.secondSupplier) || '' }}
              </span>
              <suggest-distribuitor
                v-if="item && item.mapInfo && item.mapInfo.haveSecond && !item.mapInfo.secondId"
                label="Distribuidora"
                placeholder="empresa"
                v-model="item.mapInfo.secondSupplier"
                @selected="(selected) => selectDistributor({ selected, item, position: 'second' })"
                class="suggest" />
            </td>
            <td class="right-border">{{ (item.mapInfo && item.mapInfo.haveSecond && item.mapInfo.secondLab) || '' }}</td>
            <td>{{ (item.mapInfo && item.mapInfo.haveThird && item.mapInfo.thirdCost) || '' }}</td>
            <td>
              <span
                v-if="item.mapInfo && item.mapInfo.thirdId"
                @click="cleanDistributor(item, 'third')">
                {{ (item.mapInfo && item.mapInfo.haveThird && item.mapInfo.thirdSupplier) || '' }}
              </span>
              <suggest-distribuitor
                v-if="item && item.mapInfo && item.mapInfo.haveThird && !item.mapInfo.thirdId"
                label="Distribuidora"
                placeholder="empresa"
                v-model="item.mapInfo.thirdSupplier"
                @selected="(selected) => selectDistributor({ selected, item, position: 'third' })"
                class="suggest" />
            </td>
            <td
              class="right-border">
              {{ (item.mapInfo && item.mapInfo.haveThird && item.mapInfo.thirdLab) || '' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import { SuggestEvent, SuggestDistribuitor } from '@/components/primitives'
import http from '@/communication/AuthConnection'

const haveValue = (v) => !!(v && v.length > 0)
const convertToCurency = (v) => v && !isNaN(Number(v.replace('.', '').replace(',', '.'))) ? Number(v.replace('.', '').replace(',', '.')) : false

export default {
  name: 'ImportQuoteFromMap',
  components: {
    SuggestEvent,
    SuggestDistribuitor
  },
  data () {
    return {
      form: {
        eventId: null
      },
      items: []
    }
  },
  mounted () {
    this.selectEvent({
      source: {
        _id: '5e86521d2cce7f32bea52f15'
      }
    })
  },
  methods: {
    saveMap () {
      const file = this.$refs.fileInput.files[0]

      const formData = new FormData()

      formData.append('fileUpload', file)
      formData.append('eventId', this.form.eventId)

      return http
        .post('/v1/quote/import-event', formData, {
          headers: {
            'Content-type': 'multipart/form-data'
          }
        })
    },
    async selectEvent (event) {
      this.form.eventId = event.source._id
      const { data } = await http.get(`/v1/item-association/${event.source._id}`)
      this.items = data.eventItems
    },
    loadMap () {
      const file = this.$refs.fileInput.files[0]
      const reader = new FileReader()
      reader.onload = () => this.loadFile(reader)
      reader.readAsText(file)
    },
    async loadFile (reader) {
      const mappedCsv = this.mapCsv(reader.result)
      const mappedDistributor = this.mapDistributor(mappedCsv)
      const loadedDistributor = await this.loadDistributorFromList(mappedDistributor)
      const items = this.items.map(i => ({
        ...i,
        ...this.getMappedItem(i, mappedCsv, loadedDistributor)
      }))
      this.items = items
    },
    mapDistributor (mappedCsv) {
      const distributor = mappedCsv
        .filter(i => i.winnerSupplier !== '' || i.secondSupplier !== '' || i.thirdSupplier !== '')
        .map(i => [ i.winnerSupplier || false, i.secondSupplier || false, i.thirdSupplier || false ])
        .flat()
      const uniqueDistributor = new Set(distributor)
      return Array.from(uniqueDistributor.values())
    },
    async loadDistributorFromList (distributorList) {
      try {
        const { data } = await http.get('/v1/distributor/load-from-list', { params: { distributorList } })
        return data
      } catch (error) {
        return Error(error)
      }
    },
    getMappedItem (item, mappedCsv, loadedDistributor) {
      const [ mapInfo ] = mappedCsv.filter(i => {
        const mapLot = (i.lot && i.lot.toString()) || ''
        const itemLot = (item.itemInfo && item.itemInfo.lot && item.itemInfo.lot.toString()) || ''

        const mapNumber = (i.item && i.item.toString()) || ''
        const itemNumber = (item.itemInfo && item.itemInfo.number && item.itemInfo.number.toString()) || ''
        if (mapLot === itemLot && mapNumber === itemNumber) {
          return true
        }
      })
      if (mapInfo) {
        const winnerId = this.getDistributorId(mapInfo.winnerSupplier, loadedDistributor)
        const secondId = this.getDistributorId(mapInfo.secondSupplier, loadedDistributor)
        const thirdId = this.getDistributorId(mapInfo.thirdSupplier, loadedDistributor)

        mapInfo.winnerId = winnerId || null
        mapInfo.secondId = secondId || null
        mapInfo.thirdId = thirdId || null
      }
      return { mapInfo }
    },
    mapCsv (str) {
      const rows = str.split('\r\n')
      rows.shift()

      const fields = []

      rows
        .map(r => {
          const c = r.split(';')
          if (c.length < 1) { return }
          // if (c[3] !== 'N/C') {
          const f = {
            lot: c[0],
            item: c[1],
            product: c[2],
            codProd: c[3],
            cost: convertToCurency(c[4]),
            lab: c[5],
            proposalPrice: convertToCurency(c[6]),
            haveWinner: haveValue(c[7]),
            winnerCost: haveValue(c[7]) && convertToCurency(c[7]),
            winnerSupplier: haveValue(c[8]) && c[8],
            winnerLab: haveValue(c[9]) && c[9],
            haveSecond: haveValue(c[10]) && haveValue(c[10]),
            secondCost: haveValue(c[10]) && convertToCurency(c[10]),
            secondSupplier: haveValue(c[11]) && c[11],
            secondLab: haveValue(c[12]) && c[12],
            haveThird: haveValue(c[13]) && haveValue(c[13]),
            thirdCost: haveValue(c[13]) && convertToCurency(c[13]),
            thirdSupplier: haveValue(c[14]) && c[14],
            thirdLab: haveValue(c[15]) && c[15],
            strictToME: haveValue(c[16]),
            minimumPrice: convertToCurency(c[17]),
            priceGuaranted: haveValue(c[18])
          }
          fields.push(f)
        }
      )
      return fields
    },
    getDistributorId (distributor, distributorList) {
      const distributorResult = distributorList.filter(i => distributor === i.name)
      return distributorResult.length > 0 ? distributorResult[0]._id : false
    },
    selectDistributor ({selected, item, position}) {
      item.mapInfo[`${position}Id`] = selected.source._id
      item.mapInfo[`${position}Supplier`] = selected.source.name
    },
    cleanDistributor (item, position) {
      item.mapInfo[`${position}Id`] = null
      // item.mapInfo[`${position}Supplier`] = null
    },
    async saveResult () {
      const listItems = this.items.map(item => ({
        _id: item._id,
        mapInfo: item.mapInfo
      }))

      const payload = {
        eventId: this.form.eventId,
        listItems
      }
      try {
        const { data } = await http.post('/v1/quote/set-result-from-map', payload)
        this.$toasted.success('Salvo')
        return data
      } catch (error) {
        this.$toasted.error(JSON.stringify(error))
        return Error(error)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/import-quote-from-map/ImportQuoteFromMap.vue